__webpack_require__.p = "https://ui.gamma.us-west-2.urc.advertising.amazon.dev/";